import type { MutationTree } from 'vuex';
import { EditorViewMutation } from './editor-view.constants';
import type { EditorViewState } from './editor-view.types';

export const mutations: MutationTree<EditorViewState> = {
  [EditorViewMutation.SetToken](state: EditorViewState, token: { jwt: string; exp: number }) {
    state.authToken = token;
  },

  [EditorViewMutation.SetTokenIsSynced](state: EditorViewState, isSynced: boolean) {
    state.tokenIsSynced = isSynced;
  },

  [EditorViewMutation.SetDocumentId](state: EditorViewState, documentId: string) {
    state.documentId = documentId;
  },

  [EditorViewMutation.SetRecipientId](state: EditorViewState, recipientId: string) {
    state.recipientId = recipientId;
  },

  [EditorViewMutation.SetAuthId](state: EditorViewState, authId: string) {
    state.authId = authId;
  },

  [EditorViewMutation.SetIsPreview](state: EditorViewState, isPreview: boolean) {
    state.isPreview = isPreview;
  },

  [EditorViewMutation.SetDocumentStatusSigned](state: EditorViewState, isSigned: boolean) {
    state.documentStatusSigned = isSigned;
  },

  [EditorViewMutation.SetDocumentRecalled](state: EditorViewState, isRecalled: boolean) {
    state.documentRecalled = isRecalled;
  },

  [EditorViewMutation.SetPreviewTokenExpired](state: EditorViewState, isExpired: boolean) {
    state.previewTokenExpired = isExpired;
  },
};
